export const aemImagePreUrl = `${process.env.REACT_APP_HOME_REDIRECTION}`;
export const verificationOTP = "/v3/tap/send-otp";
export const resendOTP = "/v3/tap/interface/route/api/reSendOtp";
export const sendVerificationOTP = "/v3/auth/otp-validation";
export const sendVerificationPartnerOTP = "/v3/tap/otp-verify";
export const generateEmailOtp = "/v3/tap/send-mail-otp";
export const vasBookingList =
  "/V3/tap/interface/route/api/vasBookingList?operator_id";
export const aemContentAPIEndpoint = "/aem-content?path=";
export const aemRentalListingCf =
  aemContentAPIEndpoint +
  "/content/royal-enfield/in/en/wanderlust/rental/cf/jcr:content/section-par/contentfragment_515599659.model.json";
export const selfGuidedTrips =
  aemContentAPIEndpoint +
  "/content/royal-enfield/in/en/wanderlust/jcr:content/section-par/ridelisting.model.json";
export const selfGuidedTripDetail =
  aemContentAPIEndpoint +
  "/content/royal-enfield/in/en/wanderlust/jcr:content/section-par/ridedetail.model.json";
export const customerFaq =
  aemContentAPIEndpoint +
  "/content/royal-enfield/in/en/wanderlust/jcr:content/section-par/faq.model.json";
export const header =
  "/aem-content/header?path=/content/royal-enfield/in/en/jcr:content/header-par/header.model.json";
export const footer =
  "/aem-content/footer?path=/content/royal-enfield/in/en/jcr:content/footer-par/footer.model.json";
export const reUrl = "wanderlust-dev.royalenfield.com:3000";

export const rideNearYou = "/v3/rides-events/get-rides-around-me";
export const getGstDetail = "/v3/user/gst-details";
export const storeGstDetail = "/v3/user/gst-details";
export const getPincode = "/v3/core/city-states/pincodes";

export const searchCustomer = "/v3/tap/api/searchCustomer";
export const customerReviews = "/v3/tap/api/rentalcustomer/best/reviews/5/1/0";
export const motorCycleList =
  "/v3/tap/interface/route/api/customer/productsList";
// export const addToCart = "/v3/tap/api/carts/mine/items";
export const addToCart = "/v3/tap/api/booking/carts/items";
export const bookingSummaryForCart =
  "/v3/tap/interface/route/api/rental/bookingSumary";
export const confirmAddress = "/v3/tap/api/rental/booking/confirmAddress";
export const customerBookingDetail =
  "/v3/tap/interface/route/api/rental/booking/detail";
export const updateCustomerBookingMobNo =
  "/v3/tap/interface/route/api/rental/booking/updateaddress";

export const addrentalCustomerReview = "/v3/tap/interface/route/api/review/add";

export const fetchAddress = "/v3/user/address-details";
export const bookingRiderDetailsApi =
  "/v3/tap/interface/route/api/rental/saverider";
export const customerToken = "/v3/tap/rental/cu/generate-token";

export const recommendedRides =
  "/v3/tap/interface/route/api/suggestedrideslanding";
export const checkRideroutsDetail = "/v3/rides-events/marquee-listing";
export const bookingSummaryDelete =
  "/V3/tap/interface/route/api/rental/booking/item/delete";
export const bookingAllItemDelete =
  "/V3/tap/interface/route/api/rental/booking/deleted";
export const operatorList =
  "/v3/tap/interface/route/api/operatorListing?operator_type=Rental Operator&attribute_name=Motorcycle";
export const landingAEM =
  aemContentAPIEndpoint +
  "/content/royal-enfield/in/en/wanderlust/jcr:content/section-par/contentfragment.model.json";
export const applyCouponCode =
  "/V3/tap/interface/route/api/rental/booking/applyCoupon";
export const rentalPartnerDetail =
  "/v3/tap/interface/route/api/operatorDetailsById?attribute_name=Motorcycle&operator_id=";
export const getReivewList =
  "/V3/tap/interface/route/api/rentaloperator/all/reviews";
export const operatorReviews = "/v3/tap/api/rentaloperator/best/reviews/5/1";

// export const downloadVehicleDocumentOld = "/v3/tap/rental/cu/download/temp-zip";
export const downloadVehicleDocument =
  "/v3/tap/rental/cu/download/vehicle-documents";
export const recommendedProductsList =
  "/v3/tap/interface/route/api/customer/recommendedProductsListPage";
export const downloadSigleInvoiceDocument =
  "/v3/tap/rental/cu/download/file?azurePath=";
export const cancelBookingEmailApi =
  "/v3/tap/interface/route/api/rental/booking/createcancelbookingEmail";
export const saveCancelBookingApi =
  "/v3/tap/interface/route/api/rental/booking/createcancelbooking";
export const saveAlternativeCancelBookingApi =
  "/v3/tap/interface/route/api/cancelSubstituteMotorcycle";
export const saveAlternativeCancelBookingNotificationApi =
  "/v3/tap/interface/route/api/cancelSubstituteMotorcycleNotification";
export const successOrderDetails = "/v3/tap/api/rental/op/order/successDetail/";
// "/V3/tap/interface/route/api/rental/order/successDetail/";
export const countryListApi = "/V3/tap/interface/route/api/countryList";
export const paymentInfomation =
  "/V3/tap/interface/route/api/carts/mine/payment-information";
export const updateAlternativeBike =
  "/v3/tap/interface/route/api/yesSubstituteMotorcycle";
export const getCancelDetailApi =
  "/v3/tap/interface/route/api/cancleBookingDetails";
export const getCancelPolicyApi =
  "/v3/tap/interface/route/api/operator/getcancelpolicy";
export const downloadZipInvoiceDocument =
  "/v3/tap/rental/cu/download/invoices-temp?bookingId=";
export const reviewAllProcuct = "/v3/tap/api/rentalcustomer/products/reviews";
export const alternativeBike =
  "/v3/tap/api/showSubstituteMotorcycleToCustomer?booking_id=";
export const tempDownloadZipInvoiceDocument =
  "/v3/tap/rental/cu/download/sample";

export const getMangageUserAccountInfoApi = "/v3/tap/profile/users";

export const updateMangageUserAccountInfoApi =
  "/v3/tap/rental/profile/users/update";

export const getOperatorAllReviewApi =
  "/v3/tap/interface/route/api/rentaladmin/operator/review/list";
export const updateOperatorReviewApi =
  "/v3/tap/interface/route/api/rentaladmin/publish/unpublish";

export const tempDownloadAllBookingInvoiceDocument = "/v3/tap/file-download";
export const tempDownloadAllBookingInConvainceeDocument =
  "/v3/tap/file-download";
export const adminContractHistoryDetail = "/v3/tap/rental/ad/contract-history";
export const adminContarctDisbaleBooking = "/v3/tap/rental/ad/disable-booking";
export const adminContarctEnableBooking =
  "/v3/tap/interface/route/api/disableFutureBooking?operator_guid=";
export const downLoadAllInvoiceDocument = "/v3/tap/file-download";
export const discountCompaign = "/v3/tap/interface/route/api/listDiscount";
export const updateCompaign = "/v3/tap/interface/route/api/addDiscount";

export const createCompaign = "/v3/tap/interface/route/api/addDiscount";
export const deleteCompaign = "/v3/tap/interface/route/api/deleteCouponCode";
export const modelFamilyApi = "/v3/tap/interface/route/api/motorcycleModelName";

//Admin Api Constant
export const awaitedAction = "/v3/tap/rental/ad/list-of-contract";

export const getNewRegistartion = "/v3/tap/rental/ad/requests/pre-on-boarding";
export const getFirstTimeApproval = "/v3/tap/rental/ad/requests/on-boarding";
export const getloginEncriptionstring = "/v3/auth/dashboard/encrypt";
export const getloginDetail = "/v3/tap/login";
export const getcontractDetail = "/v3/tap/rental/ad/contract-details";
export const savecontractDetail = "/v3/tap/rental/ad/update-contract";

export const adminUpdateContract = "/v3/tap/rental/ad/update-contract";
export const contractDownloadByOp = "/v3/tap/rental/op/update-contract";
export const signContractByOp = "/v3/tap/rental/op/update-contract";

// export const uprovalAction = "/v3/tap/rental/ad/request/update-request-list";

//operator API constant
export const preOnboarding = "/v3/tap/rental/op/pre-on-boarding";
export const getandSendBackReviewPreonboardingData =
  "/v3/tap/rental/op/pre-on-boarding/";
export const getFirstTimeOnboardingData = "/v3/tap/rental/op/on-boarding";
export const onBoardingAccountSetup =
  "/v3/tap/rental/op/on-boarding/account-setup/";
export const rentalOperatorForgotPassword = "/v3/tap/forgot-password";
export const rentalOperatorResetPassword = "/v3/tap/reset-password";
export const onBoardingBussinessInfo =
  "/v3/tap/rental/op/on-boarding/business-info/";
export const onBoardingBankAccountTax =
  "/v3/tap/rental/op/on-boarding/bank-tax-details/";
export const rentalAdminNewRegistrationDetails =
  "/v3/tap/rental/ad/request/pre-on-boarding/";
export const rentalAdminFirstTimeApprovalDetails =
  "/v3/tap/rental/ad/request/on-boarding/";
export const rentalOpOnBoardingCancelPolicy =
  "/v3/tap/rental/op/on-boarding/terms-and-policies/";
export const getRegistrationDetailsFromChasis =
  "/v3/user/vehicle/getFullDetails";
export const operatorUploadBulkVAS =
  "/v3/tap/interface/route/api/bulkVasUpload";
export const operatorUploadBulkMotorcycle =
  "/v3/tap/interface/route/api/bulkProductsUpload";
export const checkMobileNoExist =
  "/v3/tap/rental/op/pre-on-boarding/check-availability?mobile=";
export const checkEmailIdExist =
  "/v3/tap/rental/op/pre-on-boarding/check-availability?email=";
export const addVasApi = "/v3/tap/interface/route/api/VAS/addVASitem";
export const editVasApi = "/v3/tap/interface/route/api/VAS/editVASitem";
export const getVasApi = "/v3/tap/interface/route/api/vas/operatorVasList";
export const deleteVasApi = "/v3/tap/interface/route/api/vas/deleteVASItem";
export const addMotorcycleApi =
  "/v3/tap/interface/route/api/rentaladmin/motorcycle/save";
export const getMotorcycleApi =
  "/v3/tap/interface/route/api/rentaladmin/motorcycle/get/";
export const deleteMotorcycleApi =
  "/v3/tap/interface/route/api/rentaladmin/motorcycle/delete/";

export const getMotorcycleLocationApi =
  "/v3/tap/rental/op/on-boarding/locations";
export const submitFormApplication =
  "/v3/tap/rental/op/on-boarding/application-status";
export const listOfFleet = "/V3/tap/interface/route/api/rentaladmin/fleet/list";
export const genralviewFleet =
  "/V3/tap/interface/route/api/rentaladmin/fleet/generalView";
export const legalviewFleet =
  "/V3/tap/interface/route/api/rentaladmin/fleet/legalView";
export const saveGenralFleet =
  "/V3/tap/interface/route/api/rentaladmin/fleet/save";
export const saveLegalFleet =
  "/V3/tap/interface/route/api/rentaladmin/fleet/save";
export const getContaintImageDetails =
  "/V3/tap/interface/route/api/rentaladmin/fleet/contentView";
export const saveContaintImageDetails =
  "/V3/tap/interface/route/api/rentaladmin/fleet/save";
export const motorcycleListWithFilter =
  "/V3/tap/interface/route/api/rentaladmin/motorcycle/listing/";
export const multiMotorcycleDelete =
  "/V3/tap/interface/route/api/rentaladmin/motorcycle/multipledelete/";
export const multiMotorcycleMarkAsAvailable =
  "/V3/tap/interface/route/api/rentaladmin/motorcycle/multiplemarkasavailable/";
export const getOperatorContractDetail = "/v3/tap/rental/op/contract-details";
export const downLoadContarctDetail = "/v3/tap/rental/op/update-contract";
export const uploadDownLoadContractDetail = "/v3/tap/rental/op/update-contract";
export const bulkUploadMotorcycleList =
  "/V3/tap/interface/route/api/rentaladmin/motorcycle/bulkuploadlisting/";
export const getMotorcycleById =
  "/V3/tap/interface/route/api/rentaladmin/motorcycle/getdetailsbyid";

export const getRatingInvoiceDetailData =
  "/V3/tap/interface/route/api/rentalcustomer/review/canReviewForInvoice";
export const addRatingInvoiceDetailData =
  "/V3/tap/interface/route/api/review/addReviewByInvoice";
export const postAccountInfoDetail = "/v3/tap/rental/op/update/account";
export const postBusinaseAccountInfoDetail =
  "/v3/tap/rental/op/update/business-info";
export const getApiAccountInfoDetail = "/v3/tap/rental/op/get-account-details";
export const saveBankTaxDetailInfoDetail =
  "/v3/tap/rental/op/update/banking-tax-details";
export const updateMangeLocation = "/v3/tap/profile/update-location";
export const updateMangeIndividualLocation =
  "/v3/tap/profile/update-individual-location";
export const updateVerifyDataLocation =
  "/v3/tap/rental/op/update/locationNumberVerification";
export const bookingListApi = "/V3/tap/interface/route/api/admin/bookingList";
export const quickEditMotorcycle =
  "/V3/tap/interface/route/api/rentaladmin/motorcycle/quickeditsavemotorcycle";
export const getAccountAdminLiveDetail = "/v3/tap/rental/ad/operator-details";
export const getOpProfileDetail = "/v3/tap/profile";
export const updateOpProfilePic = "/v3/tap/profile/upload-pic";
export const updateOpProfile = "/v3/tap/profile/update-profile";
export const changeOpprofilePassword = "/v3/tap/profile/change-password";
export const getcontractHistoryDetail = "/v3/tap/rental/op/contract-history";
export const updateLiveContractApi = "/v3/tap/rental/ad/upload-new-contract";
export const updateLiveSignatureApi = "/v3/tap/rental/ad/upload-new-signature";
export const getAdminMangeUserApi = "/v3/tap/rental/ad/profile/users";
export const updateAdminMangeUserApi = "/v3/tap/rental/ad/profile/update-users";

//AEM API constant
export const operatorFaq =
  "/aem-content?path=/content/royal-enfield/in/en/wanderlust/rental/operator-faqs/jcr:content/section-par/faq.model.json";
export const aemApiForRentalLandingPage =
  "/aem-content?path=/content/royal-enfield/in/en/wanderlust/rental/cf/jcr:content/section-par/contentfragment_1545296638.model.json";
export const aemApiForRentalPartnerDetailPage =
  "/aem-content?path=/content/royal-enfield/in/en/wanderlust/rental/cf/jcr:content/section-par/contentfragment_1846354580.model.json";
export const aemApiForRentalReviewListPage =
  "/aem-content?path=/content/royal-enfield/in/en/wanderlust/rental/cf/jcr:content/section-par/contentfragment_787799746.model.json";
export const aemApiRentalEmptyBookingCartPage =
  "/aem-content?path=/content/royal-enfield/in/en/wanderlust/rental/cf/jcr:content/section-par/contentfragment_9382890.model.json";
export const aemApiRentalBookingFlowPage =
  "/aem-content?path=/content/royal-enfield/in/en/wanderlust/rental/cf/jcr:content/section-par/contentfragment_524125412.model.json";
export const aemApiBookingDetailPage =
  "/aem-content?path=/content/royal-enfield/in/en/wanderlust/rental/cf/jcr:content/section-par/contentfragment_2095978820.model.json";
export const aemApiRentalReviewAndRatingCreate =
  "/aem-content?path=/content/royal-enfield/in/en/wanderlust/rental/cf/jcr:content/section-par/contentfragment_1023012782.model.json";
export const aemApiAlternateMoterPage =
  "/aem-content?path=/content/royal-enfield/in/en/wanderlust/rental/cf/jcr:content/section-par/contentfragment_883724069.model.json";
export const selfGuidedTrailTripAEMTrips =
  aemContentAPIEndpoint +
  "/content/royal-enfield/in/en/wanderlust/rental/trails/jcr:content/section-par/ridelisting.model.json";
export const selfGuidedShortTripAEMTrips =
  aemContentAPIEndpoint +
  "/content/royal-enfield/in/en/wanderlust/rental/short-rides/jcr:content/section-par/ridelisting.model.json";

export const selfGuidedLongTripAEMTrips =
  aemContentAPIEndpoint +
  "/content/royal-enfield/in/en/wanderlust/rental/long-rides/jcr:content/section-par/ridelisting.model.json";
//upload azure
export const uploadAzureFile = "/v3/utility/uploadFilesToAzure";
export const downloadAzureFile = "/v3/utility/downloadFilesFromAzure";
export const fetchBikeDetails = "/v3/user/vehicle/fetchProfileVehicles";

//Country State & City Hierarchy
export const getCountry = "/v3/tap/interface/route/api/countryList";
export const getIndianState =
  "/v3/tap/interface/route/api/stateList?country_code=";
export const getCity =
  "/v3/tap/interface/route/api/cityList?country_code=IN&state_code=";

export const vasList = "/v3/tap/interface/route/api/vasasListByOperator";
export const vasListBulkDelete =
  "/v3/tap/interface/route/api/vas/bulkDeleteVASItem";
export const getContractDownLoad = "/v3/tap/rental/ad/generate-contract/";

export const transactionList =
  "/v3/tap/interface/route/api/rentaloperator/transactionList";

export const panalatyPaymentData = "/v3/tap/interface/route/api/penaltyListing";
//rentaladmin/cancelListing

export const operatorBookingList =
  "/v3/tap/interface/route/api/rental/operator/bookingList";
export const startTrip = "/v3/tap/interface/route/api/admin/riderstartTrip";
export const operatorBookingDetail =
  "/v3/tap/interface/route/api/rentaloperator/bookingDetail";

export const liveOperatorList =
  "/v3/tap/interface/route/api/liveOperatorListing";

export const downloadFleetPdf =
  "/V3/tap/interface/route/api/rentaladmin/motorcycle/download/";
export const pendingVerificationMotorcycleList =
  "/V3/tap/interface/route/api/rentaladmin/motorcycle/motorcycleVerificationList/";
export const uploadRiderDoc =
  "/v3/tap/interface/route/api/rentaloperator/saveRiderDocument";

export const rentalAdminUpdateApprovalDetails =
  "/v3/tap/rental/ad/request/update-operator/";
export const endTrip = "/v3/tap/interface/route/api/admin/riderendTrip";

// Admin Booking Detail
export const AdminBookingDetailApi =
  "/v3/tap/interface/route/api/admin/bookingDeatil";
export const AdminCancelBookingDetailApi =
  "/V3/tap/interface/route/api/admin/cancelBookingDeatil";

export const stateListApi =
  "/V3/tap/interface/route/api/stateList?country_code=IN";
// Operator Terms and Policies

export const OperatorTermsAndPoliciesApi =
  "/v3/tap/rental/op/get-terms-and-policies";
export const OperatorTernsAndPolicesSaveApi =
  "/v3/tap/rental/op/update/terms-and-policies";
export const operatorLocationApi = "/v3/tap/profile/location";
export const operatorModelApi =
  "/v3/tap/interface/route/api/product/attribute/options";
export const cancelBookingApi =
  "/v3/tap/interface/route/api/rental/booking/createcancelbooking";

// Operator Substitute Motorcycle
export const OperatorSubstituteListApi =
  "/V3/tap/interface/route/api/showSubstituteMotorcycleToCustomer";
export const UpdateApprovalListApi =
  "/v3/tap/rental/ad/request/update-request-list";
export const CustomerListApi = "/V3/tap/interface/route/api/admin/customerList";
export const CustomerDetailApi =
  "/V3/tap/interface/route/api/admin/customerDetail";
export const CustomerBookingListApi =
  "/V3/tap/interface/route/api/admin/customerDetailBookingList";

//operator transaction detail
export const OperatorTransactionDetails =
  "/v3/tap/interface/route/api/rentaloperator/transactionBookingDetail";
export const OperatorPenaltyTransactionDetails =
  "/v3/tap/interface/route/api/penaltyDetail?transaction_id=";
export const AdminShareDocumentAPi =
  "/V3/tap/interface/route/api/sendRiderDocument";
export const FleetDetailApi =
  "/V3/tap/interface/route/api/rentaladmin/motorcycle/getdetailsbyid";

export const cancelList =
  "/v3/tap/interface/route/api/rentaladmin/cancelListing";
export const InitiateRefundApi =
  "/v3/tap/interface/route/api/admin/approvepayment";
export const addRatingCustomerApi = "/v3/tap/interface/route/api/review/add";
export const paymentDetails =
  "/v3/tap/interface/route/api/rentaladmin/transactionBookingDetail";
export const resentPayment = "/v3/tap/interface/route/api/sapForFailure";
export const cancelPaymentDetails =
  "/v3/tap/interface/route/api/penaltyDetail?transaction_id=";
export const approvePaymentRelease =
  "/v3/tap/interface/route/api/admin/approvepayment/";

//Expired Doc Reminder
export const ExpiredDocApi =
  "/v3/tap/interface/route/api/admin/notifyExpriedDocument";

export const OperatorUpdateSubstituteMotorcycle =
  "/V3/tap/interface/route/api/updateSubstituteMotorcycle";

export const checkOutOfStockApi =
  "/v3/tap/interface/route/api/cart/validateCartItem";

// Notifications
export const getNotifications = "/v3/user/dashboard/notifications";
export const setNotifications = "/v3/node/utility/notifications/push";

export const verifyUserApi = "/v3/tap/verify/sub-user";
export const updateNotificationStatusapi = "/v3/user/dashboard/notifications";

export const productAttributeOptionsApi =
  "/v3/tap/interface/route/api/product/attribute/options";

//Share On WhatsApp
// *Old One* export const whatsAppApi = "https://api-notidev.royalenfield.com/v3/notificationcentre/sendnotification";
export const whatsAppApi = "/v3/tap/send-whatsapp-notification";

//Dashboard

export const dashboardApi = "/v3/tap/rental/ad/dashboard";
export const dashaboardTourAPI =
  "/v3/tap/interface/route/api/revenue/dashboard";
export const dashboardApiInquiry = "/v3/tap/interface/route/api/tour/inquiry";
export const dashboardTotalBookingApi = "/v3/tap/rental/ad/booking";
export const dashboardTotalRevenueApi = "/v3/tap/rental/ad/revenue";
export const partnerPerformanceApi = "/v3/tap/api/partnersperformance";
export const regionalInsightsApi = "/v3/tap/api/regionalinsights";
export const modelPerfomanceDataApi = "/v3/tap/api/modelperformance";
export const rentalPartnerDataApi = "/v3/tap/api/rental/partner/dashboard";
export const dashboardReTotalBookingApi =
  "/v3/tap/api/rental/partner/rebookings";
export const dashboardReTotalRevenueApi = "/v3/tap/api/rental/partner/revenue";
export const dashboardReMostBookedRidesApi =
  "/v3/tap/api/rental/partner/mostbookedrides";
export const dashboardReTourStatusApi =
  "/v3/tap/interface/route/api/tour/status";
export const dashboardReMostBookedToursApi =
  "/v3/tap/interface/route/api/tour/mostbooked";
export const dashboardReInventoryStatusApi =
  "/v3/tap/api/rental/partner/inventorystatus";
export const dashboardReInventoryBookingApi =
  "/v3/tap/api/rental/partner/inventorybookingscalendar";
export const ganttChartApi = "/v3/tap/interface/route/api/tour/chart";
export const bookingExcelDownload = "/v3/tap/api/admin/BookingListDownload";
export const dashboardMapApi = "/v3/tap/interface/route/api/tour/map";
export const leadManagementDetailsApi =
  "/v3/tap/interface/route/api/rental-leads/lead";
export const leadManagementReviewApi =
  "/v3/tap/interface/route/api/rental/leads/reviewsend";
export const leadManagementUpdateApi =
  "/v3/tap/interface/route/api/rentalleads/lead";
export const leadManagementViewApi =
  "/v3/tap/interface/route/api/rental-leads/lead/search?searchCriteria";
export const getLeadManagementList = "/v3/tap/interface/route/api/lead/search";

export const updateLeadManagementLeads = "/V1/rental-leads/lead";
export const leadManagementExcelDownload =
  "/v3/tap/interface/route/api/lead/search";

export const googleApi =
  "https://maps.googleapis.com/maps/api/geocode/json?sensor=true";

export const getcityManagementList =
  "/v3/tap/interface/route/api/rental-city/search";

export const getCityManagementDetailsApi =
  "/v3/tap/interface/route/api/rentalcity";

export const addCityDataApi =
  "/v3/tap/interface/route/api/rental-city/citymanagement";

export const cityManagementUpdateApi = "/v3/tap/interface/route/api/rentalcity";

export const cityManagementDeleteApi = "/v3/tap/interface/route/api/rentalcity";

export const getTourCityManagementList =
  "/v3/tap/interface/route/api/tour-city/search";

export const getTourCityManagementExcelDownload =
  "/v3/tap/interface/route/api/tour-city/search"; 

export const getTourCityManagementDetailsApi =
  "/v3/tap/interface/route/api/tour-city";

export const addTourCityDataApi =
  "/v3/tap/interface/route/api/tour-city/citymanagement";

export const tourCityManagementUpdateApi =
  "/v3/tap/interface/route/api/tourcity";

export const tourCityManagementDeleteApi =
  "/v3/tap/interface/route/api/tourcity";

export const getAdminTokenApi = "/v3/tap/interface/route/api/getTokenAdmin";

export const cityManagementExcelDownload =
  "/v3/tap/interface/route/api/rental-city/search";

export const enquiryManagementList =
  "/v3/tap/interface/route/api/rental-enquiry/enquiry/search";

export const enquiryManagementExcelDownload =
  "/v3/tap/interface/route/api/rental-enquiry/enquiry/search";

export const toursGetLeadManagementApi =
  "/v3/tap/interface/route/api/leads/search";

export const tourLeadManagementDetailsApi =
  "/V3/tap/interface/route/api/tour-leads/leads";

export const tourLeadManagementUpdateApi =
  "/V3/tap/interface/route/api/tour-leads/leads";

export const getResourceManagementList =
  "/v3/tap/interface/route/api/resource/search";
export const resourceManagementViewApi =
  "/v3/tap/interface/route/api/wanderlust-resource/resource";

export const resourceManagementDeleteApi =
  "/v3/tap/interface/route/api/wanderlust-resource/resource";

export const getPersonalizedToursApi =
  "/v3/tap/interface/route/api/personalised/search";

export const getPersonalizedToursDetailsApi =
  "/v3/tap/interface/route/api/tour-personalised/personalised";
export const aemContentPath = "/aem-content/master-data?path=";

export const getToursResourceManagementList =
  "/v3/tap/interface/route/api/resourcetour/search";

export const resourceManagementTourDeleteApi =
  "/v3/tap/interface/route/api/wanderlust-resourcetour/resource";
export const ToursleadManagementReviewApi =
  "/v3/tap/interface/route/api/tour/leads/reviewsend";

export const globalContentPath =
  "/node/assets/dashboard/wanderlust/HomePageHeader.json";

export const homePageJson =
  "/node/assets/dashboard/wanderlust/HomePageJson.json";

export const guidePageJson =
  "/node/assets/dashboard/wanderlust/guidePageResources.json";

export const motorCycleOutOfBusiness =
  "/v3/tap/interface/route/api/rental/admin/inventoryoutofbussiness";

export const topPartnersWithPendingLeads =
  "/v3/tap/interface/route/api/lead/pendingtop";

export const getInventoryStatusApi =
  "/v3/tap/interface/route/api/rental/admin/inventoryAdminstatus";

export const addNewTicketActionApi = "/v3/dashboard/wanderlust/ticket";

export const ticketCatgeoryJson =
  "/node/assets/dashboard/wanderlust/support_category.json";

export const ticketCitiesSuggestionJson =
  "/node/assets/dashboard/wanderlust/support_cities_suggestion.json";

export const getMotorcycleOutOfBusinessAPI =
  "/v3/tap/api/rental/partner/inventoryoutofbussiness";

export const verifyCaptchaApi = "/v3/core/recaptcha/new-verify?recaptchaId=";

export const updatePartnerPriorityApi = "/v3/tap/interface/route/api/operator/priority"
